<template>
  <modal
    title="Profile Type"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="py-6">
      <div>
        <label class="label">Profile Type:</label>
        <input
          type="text"
          class="input"
          placeholder="Enter"
          v-model="profileType"
        />
      </div>

      <div class="actions pt-4 flex justify-between">
        <div class="cursor-pointer" @click="closeModal">
          <p>Cancel</p>
        </div>
        <div>
          <primary-button
            buttonText="Save"
            :loading="loading"
            @click="submit"
          />
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    selectedProfileType: {
      required: false,
    },
  },
  data() {
    return {
      loading: false,
      profileType: "",
    };
  },
  watch: {
    selectedProfileType(val) {
      this.profileType = val;
    },
    showModal() {
      // stop loading action if it exists whenever the modal closes
      this.loading = false;
      // this.profileType = "";
    },
  },
  methods: {
    closeModal() {
      this.profileType = "";
      this.$emit("close-modal");
    },
    submit() {
      this.loading = true;
      // checks if it is an edit action by checking length of selected profile name
      if (this.selectedProfileType.length > 0) {
        this.$emit("update", this.profileType);
      } else {
        this.$emit("create", this.profileType);
      }
    },
  },
};
</script>

<style scoped></style>
